// src/services/categoryService.js
import api from '../utils/api';  // Your API instance

const CATEGORY_BASE_URL = '/categories';

const categoryService = {
  // Get all categories with pagination, filtering, and search
  getCategories: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add search
      if (params.search) queryParams.append('search', params.search);
      
      // Add filters
      if (params.type) queryParams.append('type', params.type);
      if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
      if (params.parentId) queryParams.append('parentId', params.parentId);
      
      // Add sorting
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      const response = await api.get(`${CATEGORY_BASE_URL}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get single category by ID
  getCategoryById: async (id) => {
    try {
      const response = await api.get(`${CATEGORY_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get category by slug
  getCategoryBySlug: async (slug) => {
    try {
      const response = await api.get(`${CATEGORY_BASE_URL}/slug/${slug}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new category
  createCategory: async (categoryData) => {
    try {
      const response = await api.post(CATEGORY_BASE_URL, categoryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update category
  updateCategory: async (id, categoryData) => {
    try {
      const response = await api.put(`${CATEGORY_BASE_URL}/${id}`, categoryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete category
  deleteCategory: async (id) => {
    try {
      const response = await api.delete(`${CATEGORY_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get category tree (hierarchical)
  getCategoryTree: async (type) => {
    try {
      const params = type ? `?type=${type}` : '';
      const response = await api.get(`${CATEGORY_BASE_URL}/tree${params}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get category usage statistics
  getCategoryStats: async (id) => {
    try {
      const response = await api.get(`${CATEGORY_BASE_URL}/${id}/stats`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Bulk delete categories
  bulkDeleteCategories: async (ids) => {
    try {
      const response = await api.delete(`${CATEGORY_BASE_URL}/bulk`, { data: { ids } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Upload category image
  uploadCategoryImage: async (id, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.post(
        `${CATEGORY_BASE_URL}/${id}/image`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Reorder categories
  reorderCategories: async (orderedIds) => {
    try {
      const response = await api.post(`${CATEGORY_BASE_URL}/reorder`, { orderedIds });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default categoryService;